Ext.define('SA.data.mixin.OneLocation', {

    locationProperty: 'locationItems',

    addLocation(location) {
        return this.setLocation(location);
    },

    containsLocation(locationSeries) {
        locationSeries = SA.data.LocationsCache.toLocationSeries(locationSeries);

        return this.getLocation() === locationSeries;
    },

    getLocation() {
        var location = this.data[this.locationProperty];

        if (Array.isArray(location)) {
            location = location[0];
        }

        return SA.data.LocationsCache.toLocationSeries(location);
    },

    getLocations() {
        var location = this.getLocation();

        return location ? [location] : [];
    },

    hasLocation() {
        return !!this.getLocation();
    },

    onCustomLocationUpdate(location) {
        location = SA.data.LocationsCache.toLocationItem(location);

        if (this.containsLocation(location)) {
            this.onCustomLocationUpdateImpl(location);

            this.fireEvent('change:location', this);
        }
    },

    onCustomLocationUpdateImpl: Ext.emptyFn,

    removeLocation(location) {
        if (this.containsLocation(location)) {
            this.setLocation(null);
        }

        this.fireEvent('change:location', this);
    },

    setLocation(location) {
        location = SA.data.LocationsCache.toLocationItem(location);

        if (this.containsLocation(location)) {
            return null;
        }

        if (this.setLocationImpl(location) === false) {
            return false;
        }

        this.fireEvent('change:location', this);

        return true;
    },

    setLocationImpl(location) {
        var data = this.data,
            locationProperty = this.locationProperty,
            locationItems = data[locationProperty];

        if (Array.isArray(locationItems)) {
            locationItems = location ? [location] : [];
        }
        else {
            locationItems = location;
        }

        data[locationProperty] = locationItems;
    }
});
